import { useNavigate } from "react-router-dom";
import AdminLayout from "../../commponents/layout/adminLayout";
import DosForm from "../../commponents/dos/DosForm";
import { createDos } from "../../api/dosApi";
import { showSuccess } from "../../utils/ alert";
import type { DosPayload } from "../../type/dos";

export default function AddDos() {
  const navigate = useNavigate();

  // Error simpan (400/409/...) ditampilkan oleh DosForm.
  const handleSubmit = async (payload: DosPayload) => {
    const response = await createDos(payload);
    const created = response.data.data;

    await showSuccess("DOS created successfully.");
    navigate(created?.id ? `/dos/${created.id}` : "/dos");
  };

  return (
    <AdminLayout>
      <DosForm title="Add DOS" onSubmit={handleSubmit} onCancel={() => navigate("/dos")} />
    </AdminLayout>
  );
}
